import { useCallback } from 'react'

import { sendClickAnaliticsEvent } from 'Analitics'

type Props = {
  id: string
  onClick: () => void
  children: React.ReactNode
  disabled?: boolean
}

export default function Button({ id, onClick, children, disabled }: Props) {
  const handleClick = useCallback(() => {
    sendClickAnaliticsEvent(id)
    onClick()
  }, [id, onClick])

  return (
    <button
      className="btn btn-sm font-sans dark:hover:bg-slate-950"
      onClick={handleClick}
      disabled={disabled}
    >
      {children}
    </button>
  )
}
